module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tree"
  }, _vm._l((_vm.nodes), function(node) {
    return _c('node', {
      key: node.id,
      attrs: {
        "node": node,
        "TreeModel": _vm.TreeModel,
        "showCounter": _vm.showCounter
      },
      on: {
        "check": _vm.emitCheck
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b438d6f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/i-tree/src/tree.vue
// module id = 608
// module chunks = 0